'use client';

import { useEffect } from 'react';

import { loginUser } from '@/features/auth/authSlice';
import { authService } from '@/services/authService';
import { useAppDispatch } from '@/store/hooks';

interface AuthInitializerProps {
  onComplete?: () => void;
  onError?: (error: any) => void;
}

export default function AuthInitializer({ onComplete, onError }: AuthInitializerProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    console.log('initAuth');
    const initAuth = async () => {
      try {
        const session = await authService.checkSession();
        if (session) {
          dispatch(loginUser.fulfilled(session, '', { username: '', password: '' }));
        }
        onComplete?.();
      } catch (error) {
        console.error('Error checking session:', error);
        onError?.(error);
      }
    };

    initAuth();
  }, [dispatch, onComplete, onError]);

  return null;
}
